module.exports = __webpack_public_path__ + "img/selfies.f14107a9.png";